<section id="content">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>Package Configuration List</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/super/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/super/'+AppFrontRoutes.INSTALLATION_LIST">Package Configuration List</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body">
              <div role="tabpanel">

            
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a class="plus-add" href="javascript:void(0)" (click)="addInstall()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Import">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>

                        </div>
                      </div>                     
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="records">
                        <thead>
                          <tr>
                            <th>Package Name</th>
                            <th>Creation date</th>
                            <th>Active Modules</th>
                            <th>Values</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let record of records let i = index" id="{{record.id}}">
                            <td>{{record.package_name}}</td>
                            <td>{{record.created_date}}</td>
                            <td>{{record.array_lable}}</td>
                            <td>{{record.array_value}}</td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.id)"><i
                                        class="fa fa-trash"></i> Delete</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action" (click)="editPackage(record.id)"><i
                                        class="fa fa-edit"></i> Edit</a></li>
                                  <li><a [routerLink]="['/super/'+AppFrontRoutes.ADMIN_PACKAGE_LIST+'/'+record.id]"
                                      class="blue_action"><i class="glyphicon glyphicon-eye-open"></i>View</a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>

                          
                        </tbody>

                      </table>
                    </div>
                  </div>

              

                </div>

              </div>


            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ lang?.dataImport }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_servicing.csv" download="">{{ lang?.downloadCsv }}</a></font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>
    </div>
  </div>
</div>
